// extracted by mini-css-extract-plugin
export default {"root":"Card_root__5IR0-","cardInner":"Card_cardInner__KmBLa","cardImages":"Card_cardImages__sEI2p","cardTexts":"Card_cardTexts__7cNbF","label":"Card_label__FH571"};